import moment from 'moment';
import { notificationError, notificationInfo } from '../../common/compornents/notification';
import { Message } from '../../common/constants/Message';
import { generateMessage } from '../../common/util/MessageUtil';

// 受注ヘッダー必須チェック
export const RequiredHeaders = (nonyusaki: any) => {
  let result: Boolean = true;

  if (nonyusaki === null || nonyusaki === undefined || nonyusaki === '') {
    result = false;
    notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR001, '納入先'));
  }
  return result;
};

// 受注明細件数チェック
export const RequiredDetailsCnt = (details: any[]) => {
  let result: Boolean = true;

  if (details.length <= 0 || details === null || details === undefined) {
    result = false;
    notificationError('注文入力', Message.ERROR_MASSAGE.ERR016);
  }
  return result;
};

// 受注明細必須チェック
export const RequiredDetails = async (
  hinCd: any,
  irime: any,
  irimeKbn: any,
  jyuSu: any,
  nisugataKbn: any,
  mihonNo: any,
  genbutuNo: any,
  geniraiKbn: any,
  kihonIroCd: any
) => {
  let result: Boolean = true;

  if (!hinCd) {
    result = false;
    notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR001, '製品'));
  } else if (!irime) {
    result = false;
    notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR001, '入目'));
  } else if (!irimeKbn) {
    result = false;
    notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR001, '入目単位'));
  } else if (!jyuSu) {
    result = false;
    notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR001, '数量'));
  } else if (!nisugataKbn) {
    result = false;
    notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR001, '数量単位'));
  } else if (
    (geniraiKbn === undefined || geniraiKbn === false) &&
    (kihonIroCd === undefined || kihonIroCd === '')
  ) {
    result = false;
    notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR001, '基本色調'));
  } else if (
    mihonNo !== undefined &&
    mihonNo !== null &&
    mihonNo !== '' &&
    (genbutuNo === undefined || genbutuNo === null || genbutuNo === '')
  ) {
    result = false;
    notificationError('注文入力', Message.ERROR_MASSAGE.ERR006);
  }
  return result;
};

// 製品存在チェック
export const ExistenceHinCd = () => {
  notificationError('注文入力', Message.ERROR_MASSAGE.ERR010);
};

// 工事管理番号存在チェック
export const ExistenceKojiNo = () => {
  notificationError('注文入力', Message.ERROR_MASSAGE.ERR011);
};

// データ更新時受注データ存在チェックエラー
export const ExistenceJuchuData = () => {
  notificationError('注文入力', Message.ERROR_MASSAGE.ERR012);
};

// データ更新時受注データ削除済みエラー
export const DeletedJuchuData = () => {
  notificationError('注文入力', Message.ERROR_MASSAGE.ERR013);
};

// データ更新時受注データ更新済みエラー
export const UpdatedJuchuData = () => {
  notificationInfo('注文入力', Message.INFO_MASSAGE.INF011);
};

// システムエラー
export const SystemError = (msg: string) => {
  notificationError('注文入力', generateMessage(Message.ERROR_MASSAGE.ERR999, msg));
};

// 日付型チェック
export const checkDateData = (data: any) => {
  if (data !== undefined && data !== null && data !== '') {
    if (typeof data === 'string' && moment(data).isValid()) {
      return true;
    }
    return false;
  }
};

// 日付型チェック2
export const checkMomentData = (data: any) => {
  if (data !== undefined && data !== null && data !== '') {
    if (moment(data).isValid()) {
      return true;
    }
    return false;
  }
};

// 必須入力チェック
export const checkRequired = (data: any) => {
  if (data !== undefined && data !== null && data !== '') {
    return true;
  }
  return false;
};
